module.exports = __webpack_public_path__ + "media/images/cover/garage-1d6e3e108845df4a709e18a0ab78c76d.jpg";